// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___mFs4r","m-signature-pad--body":"styles__m-signature-pad--body___I_p3M","m-signature-pad--footer":"styles__m-signature-pad--footer___2c__r","description":"styles__description___3uxV9","button":"styles__button___3M4u-","clear":"styles__clear___1IepZ","save":"styles__save___29wsL","m-signature-pad":"styles__m-signature-pad___1x5OD","github":"styles__github___17LU4","messageBox":"styles__messageBox___1oU9i","error":"styles__error___2hOoS","completedList":"styles__completedList___BfLIA"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/MessageBox/styles.scss
// module id = Brzw
// module chunks = client